import { RouterProvider } from "react-router-dom";
import router from "./routes/index";
import { useEffect, useState } from "react";
import { CssBaseline } from "@mui/material";
import { GoogleMapProvider } from "./GoogleMapContext";
import { getLayoutConfig } from "./store/slices/layoutConfigSlice";
import { useAppDispatch } from "./store/hooks";
import Loader from "./components/Loader/Loader";

const App = () => {
  const dispatch = useAppDispatch();

  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        await dispatch(getLayoutConfig());
      } finally {
        setShowLoader(false);
      }
    };

    initializeApp();
  }, [dispatch]);

  if (showLoader) {
    return <Loader />;
  }

  return (
    <>
      <CssBaseline />
      <GoogleMapProvider>
        <RouterProvider router={router} />
      </GoogleMapProvider>
    </>
  );
};

export default App;